module.exports = __webpack_public_path__ + "img/180.243ddf44.jpg";